// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react'
import { FooterControl } from '../components'
import { CurrentUser, Device } from '../services'
import './Home.scss'


interface ContainerProps {
  device: Device
  nav: HTMLIonNavElement
  user: CurrentUser
}


const DeviceDetail: React.FC<ContainerProps> = ({
  device,
  nav,
  user
}) => {
  if (!nav) { return null }
  return (
    <IonPage>
      <IonHeader collapse="fade">
        <IonToolbar no-border>
          <IonTitle size="large">{device.name}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent scrollY={false}>
      </IonContent>
      <FooterControl nav={nav} user={user}/>
    </IonPage>
  );
};

export  { DeviceDetail }
